import classNames from 'classnames';
import type {
  OverlayScrollbarsComponentProps,
  OverlayScrollbarsComponentRef,
} from 'overlayscrollbars-react';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';
import React, { forwardRef } from 'react';
import { UiThemeSetting } from '../graphql/generated/graphql';
import useUiTheme from '../utils/useUiTheme';
import * as styles from './ScrollArea.module.scss';

const ScrollArea = forwardRef<
  OverlayScrollbarsComponentRef<'div'>,
  OverlayScrollbarsComponentProps<'div'>
>(({ className, ...props }, ref) => {
  const uiTheme = useUiTheme();

  return (
    <OverlayScrollbarsComponent
      className={classNames(styles.container, className)}
      options={{
        scrollbars: {
          theme:
            uiTheme === UiThemeSetting.Dark
              ? 'os-theme-light'
              : 'os-theme-dark',
        },
        overflow: { x: 'hidden' },
      }}
      ref={ref}
      defer
      {...props}
    />
  );
});

export default ScrollArea;
